import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FolderX, LUCIDE_ICONS, LucideAngularModule, LucideIconProvider } from 'lucide-angular';

@Component({
  selector: 'app-empty-filter-state',
  imports: [CommonModule, LucideAngularModule],
  providers: [
    {
      provide: LUCIDE_ICONS,
      multi: true,
      useValue: new LucideIconProvider({
        FolderX,
      }),
    },
  ],
  templateUrl: './empty-filter-state.html',
  styleUrl: './empty-filter-state.css',
})
export class EmptyFilterState {
  @Input() title = 'No se han encontrado resultados';
  @Input() message = 'Ajusta los filtros aplicados o limpia la búsqueda para volver a intentarlo.';
}
